<template>
  <div class="page-header-parent">
    <div class="discolorheader page-header" style="z-index: 100">
      <div class="main page-header__main">
        <div class="main-bottom">
          <div class="bottom-wear-left fboxYcenter">
            <div class="wear-left-logo__wrapper">
              <router-link to="/" class="scg-logo">
                <img src="/templates/scgidc/img/logo-white.svg">
              </router-link>
            </div>
            <ul>
              <router-link class="relative" to="/activity" rel="nofollow">
                <li class="submenu activity fboxRow" data-href="nav-activity">
                  <span class="text">{{ t('header.activities') }}</span>
                </li>
                <i class="pls-nav-tag hot">
                  <span class="pls-nav-tag-text">{{ t('common.hot') }}</span>
                </i>
              </router-link>
              <li class="submenu dropdownshow" :class="{ 'is-active': activeDropdown === 'product' }" 
                  data-href="nav-product"
                  @mouseenter="handleMenuEnter('product')" 
                  @mouseleave="handleMenuLeave">
                <span>{{ t('header.products') }}</span>
                <span class="glyphicon glyphicon-chevron-down"></span>
              </li>
              <li class="submenu dropdownshow realtive" :class="{ 'is-active': activeDropdown === 'service' }"
                  data-href="nav-service"
                  @mouseenter="handleMenuEnter('service')" 
                  @mouseleave="handleMenuLeave">
                <span>{{ t('header.solutions') }}</span>
                <span class="glyphicon glyphicon-chevron-down"></span>
              </li>
              <li class="submenu dropdownshow" :class="{ 'is-active': activeDropdown === 'cooperation' }"
                  data-href="nav-cooperation"
                  @mouseenter="handleMenuEnter('cooperation')" 
                  @mouseleave="handleMenuLeave">
                <span>{{ t('header.partners') }}</span>
                <span class="glyphicon glyphicon-chevron-down"></span>
              </li>
              <li class="submenu dropdownshow" :class="{ 'is-active': activeDropdown === 'aboutUs' }"
                  data-href="nav-aboutUs"
                  @mouseenter="handleMenuEnter('aboutUs')" 
                  @mouseleave="handleMenuLeave">
                <span>{{ t('header.aboutUs') }}</span>
                <span class="glyphicon glyphicon-chevron-down"></span>
              </li>
            </ul>
          </div>
          <div class="bottom-wear-right fboxYcenter">
            <div class="bottom-wear-right fboxYcenter">
              <!-- 搜索框 - 高度擑满、无圆角、下方浮窗 -->
              <div class="header-search-wrapper" :class="{ 'is-expanded': showSearchPanel }">
                <div class="header-search-box" @click="openSearchPanel">
                  <div class="search-keyword-scroll" v-if="!showSearchPanel">
                    <transition name="keyword-slide" mode="out-in">
                      <span class="keyword-item" :key="currentKeywordIndex">{{ searchKeywords[currentKeywordIndex] }}</span>
                    </transition>
                  </div>
                  <input 
                    v-else
                    ref="searchInput"
                    type="text" 
                    class="search-input-inline" 
                    :placeholder="t('header.search')" 
                    v-model="searchQuery"
                    @keyup.enter="handleSearch"
                  />
                  <div class="search-actions">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="11" cy="11" r="8"/>
                      <path d="m21 21-4.35-4.35"/>
                    </svg>
                    <svg v-if="showSearchPanel" @click.stop="closeSearchPanel" class="close-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                  </div>
                </div>
                <!-- 下方浮窗 - 使用Arco Design Tag -->
                <div class="search-dropdown" v-if="showSearchPanel" @click.stop>
                  <div class="search-section">
                    <div class="search-section-title">{{ t('search.quickAccess') }}</div>
                    <a-space wrap>
                      <a-tag color="arcoblue" size="large" @click="goTo('/store/hk')">
                        <template #icon><icon-computer /></template>
                        {{ t('search.hkServer') }}
                      </a-tag>
                      <a-tag color="arcoblue" size="large" @click="goTo('/store/yun')">
                        <template #icon><icon-cloud /></template>
                        {{ t('search.cloudServer') }}
                      </a-tag>
                      <a-tag color="arcoblue" size="large" @click="goTo('/store/antiddos')">
                        <template #icon><icon-safe /></template>
                        {{ t('search.ddosProtection') }}
                      </a-tag>
                      <a-tag color="arcoblue" size="large" @click="goTo('/store/ssl')">
                        <template #icon><icon-lock /></template>
                        {{ t('search.sslCertificate') }}
                      </a-tag>
                    </a-space>
                  </div>
                  <div class="search-section">
                    <div class="search-section-title">{{ t('search.hotProducts') }}</div>
                    <a-space wrap>
                      <a-tag color="red" size="large" @click="goTo('/store/bgpb')">
                        <template #icon><icon-fire /></template>
                        {{ t('search.bgpServer') }}
                      </a-tag>
                      <a-tag color="orangered" size="large" @click="goTo('/store/colocation')">
                        <template #icon><icon-storage /></template>
                        {{ t('search.colocation') }}
                      </a-tag>
                      <a-tag color="orange" size="large" @click="goTo('/store/zhan-qun-fu-wu-qi')">
                        <template #icon><icon-apps /></template>
                        {{ t('search.multiIpServer') }}
                      </a-tag>
                    </a-space>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-wrapper fboxRow">
              <div class="tpm-prod-hero__btn-group">
                <a onclick="window.location.href='/auth'" class="tpm-btn tpm-prod-hero__btn tpm-btn--lightTodeep tpm-btn-header-right">
                  <span class="tpm-btn__text">{{ t('header.login') }}</span>
                </a>
                <!-- 注册按钮带福利弹窗 -->
                <div class="ng-topnav__sign">
                  <div class="ng-topnav__sign-inner" onclick="window.location.href='/auth'">{{ t('header.register') }}</div>
                  <div class="ng-topnav__sign-dropdown-wrap">
                    <div class="ng-topnav__sign-dropdown">
                      <div class="ng-topnav__sign-hd">
                        <div class="ng-topnav__sign-icon"></div>
                        <div class="ng-topnav__sign-title">{{ t('header.registerBenefits') }}</div>
                      </div>
                      <div class="ng-topnav__sign-list">
                        <div class="ng-topnav__sign-item">{{ t('header.benefit1') }}</div>
                        <div class="ng-topnav__sign-item">{{ t('header.benefit2') }}</div>
                        <div class="ng-topnav__sign-item">{{ t('header.benefit3') }}</div>
                      </div>
                      <div class="ng-topnav__sign-ft">
                        <div class="ng-topnav__sign-btn" onclick="window.location.href='/auth'">
                          <span class="ng-topnav__sign-btn-text">{{ t('header.signUpFree') }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mega Dropdown Menu -->
      <div class="pls-nav-dropdown" :style="dropdownStyle" 
           @mouseenter="handleDropdownEnter" 
           @mouseleave="handleDropdownLeave">
        <div class="pls-nav-dropdown__wrapper" :class="{ 'is-active': isDropdownActive }">
          <!-- Products Dropdown -->
          <div class="pls-nav-dropdown-inner" :class="{ 'is-active': activeDropdown === 'product' }" data-dropdown="product">
            <aside class="pls-nav-dropdown-side">
              <div class="pls-nav-dropdown-side-inner">
                <div class="pls-nav-cat-menu">
                  <ul class="pls-nav-cat-menu-list">
                    <div class="tpm-hero2__ctrl-item-line" :style="{ top: lineTop + 'px' }"></div>
                    <li v-for="(cat, idx) in productCategories" :key="cat.id"
                        class="pls-nav-cat-menu-item" 
                        :class="{ 'is-active': activeCat === cat.id }"
                        :data-nav="'product-' + cat.id"
                        @mouseenter="handleCatHover(cat.id, idx)">
                      <span class="pls-nav-cat-menu-item-link">{{ cat.name }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </aside>
            <div class="pls-nav-dropdown-content">
              <div class="pls-nav-dropdown-content-inner">
                <!-- All Products -->
                <div class="pls-nav-dropdown-main nav-menu-dropdown" :class="{ 'is-active': activeCat === 'all' }" id="navContent-product-all">
                  <div class="nav-menu-wrap">
                    <div v-for="group in allProductGroups" :key="group.title" class="menu-item">
                      <div class="menu-item-title">
                        <img :src="group.icon" class="title-flag"> {{ group.title }}
                      </div>
                      <div class="menu-item-category">
                        <a v-for="item in group.items" :key="item.name" :href="item.link">
                          <div class="category-li">{{ item.name }} <span v-if="item.tag" class="hot__flag ml-10">{{ item.tag }}</span></div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Server Products -->
                <div class="pls-nav-dropdown-main server" :class="{ 'is-active': activeCat === 'server' }" id="navContent-product-server">
                  <div class="view-column w100">
                    <div class="tp-grid__layout">
                      <div class="tp-grid__row tp-grid--gutter-8">
                        <div v-for="item in serverProducts" :key="item.title" class="tp-grid__col tp-grid__col--12 tp-grid__col--pad-12 tp-grid__col--phone-24">
                          <div class="pls-nav-dropdown-item">
                            <div class="nav-dropdown-item-title">{{ item.title }}</div>
                            <div class="nav-dropdown-item-desc">{{ item.desc }}</div>
                            <div class="tpm-prod-hero__btn-group-wrapper fboxYcenter">
                              <div class="tpm-prod-hero__btn-group">
                                <a :href="item.link" rel="nofollow" class="tpm-btn tpm-prod-hero__btn tpm-btn--lightTodeep">
                                  <span class="tpm-btn__text">{{ t('home.productDetails') }}</span>
                                </a>
                              </div>
                              <a :href="item.consoleLink" rel="nofollow" target="_self" class="tp-link tpm-link" style="z-index: 1;">
                                <span class="tp-link__inner">{{ t('home.console') }}</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Other category dropdowns... -->
              </div>
            </div>
          </div>

          <!-- Solutions Dropdown -->
          <div class="pls-nav-dropdown-inner" :class="{ 'is-active': activeDropdown === 'service' }" data-dropdown="service">
            <aside class="pls-nav-dropdown-side">
              <div class="pls-nav-dropdown-side-inner">
                <div class="pls-nav-cat-menu pls-nav-cat-menu__single">
                  <div>
                    <div class="pls-nav-cat-menu-title mb-16">{{ t('solutions.service') }}</div>
                    <p class="pls-nav-cat-menu-desc">{{ t('solutions.serviceDesc') }}</p>
                  </div>
                </div>
              </div>
            </aside>
            <div class="pls-nav-dropdown-content">
              <div class="pls-nav-dropdown-content-inner">
                <div class="pls-nav-dropdown-main is-active">
                  <div class="view-column w100">
                    <div class="tp-grid__layout">
                      <div class="tp-grid__row tp-grid--gutter-8">
                        <div v-for="item in serviceItems" :key="item.titleKey" class="tp-grid__col tp-grid__col--12 tp-grid__col--pad-12 tp-grid__col--phone-24">
                          <div class="pls-nav-dropdown-item">
                            <div class="nav-dropdown-item-title">{{ t(item.titleKey) }}</div>
                            <div class="nav-dropdown-item-desc">{{ t(item.descKey) }}</div>
                            <div class="tpm-prod-hero__btn-group-wrapper fboxYcenter">
                              <div class="tpm-prod-hero__btn-group">
                                <a href="javascript:void(0)" class="tpm-btn tpm-prod-hero__btn tpm-btn--primary tpm-btn__kefu">
                                  <span class="tpm-btn__text">{{ t('home.contactUs') }}</span>
                                </a>
                                <a :href="item.link" rel="nofollow" class="tpm-btn tpm-prod-hero__btn tpm-btn--lightTodeep">
                                  <span class="tpm-btn__text">{{ t('home.productDetails') }}</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Partners Dropdown -->
          <div class="pls-nav-dropdown-inner" :class="{ 'is-active': activeDropdown === 'cooperation' }" data-dropdown="cooperation">
            <aside class="pls-nav-dropdown-side">
              <div class="pls-nav-dropdown-side-inner">
                <div class="pls-nav-cat-menu pls-nav-cat-menu__single">
                  <div>
                    <div class="pls-nav-cat-menu-title mb-16">{{ t('header.partners') }}</div>
                    <p class="pls-nav-cat-menu-desc">{{ t('partners.partnerWithUs') }}</p>
                  </div>
                </div>
              </div>
            </aside>
            <div class="pls-nav-dropdown-content">
              <div class="pls-nav-dropdown-content-inner">
                <div class="pls-nav-dropdown-main is-active">
                  <div class="view-column w100">
                    <div class="tp-grid__layout">
                      <div class="tp-grid__row tp-grid--gutter-8">
                        <div class="tp-grid__col tp-grid__col--12 tp-grid__col--pad-12 tp-grid__col--phone-24">
                          <div class="pls-nav-dropdown-item">
                            <div class="nav-dropdown-item-title">{{ t('partners.partners') }}</div>
                            <div class="nav-dropdown-item-desc">{{ t('partners.joinProgram') }}</div>
                            <div class="tpm-prod-hero__btn-group-wrapper fboxYcenter">
                              <div class="tpm-prod-hero__btn-group">
                                <router-link to="/partner" class="tpm-btn tpm-prod-hero__btn tpm-btn--primary">
                                  <span class="tpm-btn__text">{{ t('common.learnMore') }}</span>
                                </router-link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tp-grid__col tp-grid__col--12 tp-grid__col--pad-12 tp-grid__col--phone-24">
                          <div class="pls-nav-dropdown-item">
                            <div class="nav-dropdown-item-title">{{ t('partners.affiliateProgram') }}</div>
                            <div class="nav-dropdown-item-desc">{{ t('partners.affiliateDesc') }}</div>
                            <div class="tpm-prod-hero__btn-group-wrapper fboxYcenter">
                              <div class="tpm-prod-hero__btn-group">
                                <router-link to="/auth" class="tpm-btn tpm-prod-hero__btn tpm-btn--primary">
                                  <span class="tpm-btn__text">{{ t('common.learnMore') }}</span>
                                </router-link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- About Us Dropdown -->
          <div class="pls-nav-dropdown-inner" :class="{ 'is-active': activeDropdown === 'aboutUs' }" data-dropdown="aboutUs">
            <aside class="pls-nav-dropdown-side">
              <div class="pls-nav-dropdown-side-inner">
                <div class="pls-nav-cat-menu pls-nav-cat-menu__single">
                  <div>
                    <div class="pls-nav-cat-menu-title mb-16">{{ t('header.aboutUs') }}</div>
                    <p class="pls-nav-cat-menu-desc">{{ t('aboutMenu.expertise') }}</p>
                  </div>
                </div>
              </div>
            </aside>
            <div class="pls-nav-dropdown-content">
              <div class="pls-nav-dropdown-content-inner">
                <div class="pls-nav-dropdown-main is-active nav-menu-dropdown">
                  <div class="nav-menu-wrap">
                    <div class="menu-item">
                      <div class="menu-item-title">
                        <img src="/templates/scgidc/images/scg/icon/datacenter.gif" class="title-flag">{{ t('aboutMenu.infrastructure') }}
                      </div>
                      <div class="menu-item-category">
                        <router-link v-for="dc in datacenters" :key="dc.slug" :to="'/dc/' + dc.slug">
                          <div class="category-li">{{ dc.name }}</div>
                        </router-link>
                      </div>
                    </div>
                    <div class="menu-item">
                      <div class="menu-item-title">
                        <img src="/templates/scgidc/images/scg/icon/about.gif" class="title-flag"> {{ t('header.aboutUs') }}
                      </div>
                      <div class="menu-item-category">
                        <router-link to="/company"><div class="category-li">{{ t('aboutMenu.companyIntro') }}</div></router-link>
                        <router-link to="/history"><div class="category-li">{{ t('aboutMenu.history') }}</div></router-link>
                        <router-link to="/joinus"><div class="category-li">{{ t('aboutMenu.joinUs') }}</div></router-link>
                        <router-link to="/contact"><div class="category-li">{{ t('aboutMenu.contactUs') }}</div></router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Header -->
  <header class="modile-header newModile-header">
    <nav class="navbar">
      <div class="navbar-header">
        <div class="navHeader-left">
          <router-link to="/">
            <div class="content-logo">
              <img src="/templates/scgidc/img/logo-white.svg">
            </div>
          </router-link>
        </div>
        <div class="navHeader-right fboxRow">
          <div class="rightIcon-item personInfo">
            <div class="personInfo-userLogo fboxRow">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="volcfe-nav-mob-button volcfe-nav-mobile"><path d="M11.9976 16.5C15.0516 16.5 17.9081 17.7521 19.971 19.922C20.3515 20.3222 20.3355 20.9552 19.9352 21.3357C19.535 21.7163 18.902 21.7003 18.5215 21.3C16.8324 19.5233 14.4979 18.5 11.9976 18.5C9.47485 18.5 7.12122 19.542 5.42958 21.3468C5.0519 21.7498 4.41907 21.7703 4.01611 21.3926C3.61315 21.0149 3.59265 20.3821 3.97033 19.9792C6.03624 17.7749 8.91613 16.5 11.9976 16.5ZM11.95 2.5C15.4017 2.5 18.2 5.29822 18.2 8.75C18.2 12.2018 15.4017 15 11.95 15C8.49818 15 5.69995 12.2018 5.69995 8.75C5.69995 5.29822 8.49818 2.5 11.95 2.5ZM11.95 4.5C9.60275 4.5 7.69995 6.40279 7.69995 8.75C7.69995 11.0972 9.60275 13 11.95 13C14.2972 13 16.2 11.0972 16.2 8.75C16.2 6.40279 14.2972 4.5 11.95 4.5Z"></path></svg>
            </div>
          </div>
          <div class="rightIcon-item iconButton" @click="toggleMobileMenu">
            <svg v-if="mobileMenuOpen" fill="none" stroke="currentColor" stroke-width="4" viewBox="0 0 48 48" aria-hidden="true" focusable="false" class="arco-icon arco-icon-close" style="height: 18px; width: 18px; cursor: pointer;"><path d="M9.857 9.858 24 24m0 0 14.142 14.142M24 24 38.142 9.858M24 24 9.857 38.142"></path></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="volcfe-nav-mob-button volcfe-nav-mobile"><path fill-rule="evenodd" d="M19.8 17c.11 0 .2.09.2.2v1.6c0 .11-.09.2-.2.2H4.2c-.11 0-.2-.09-.2-.2v-1.6c0-.11.09-.2.2-.2h15.6zm0-6c.11 0 .2.09.2.2v1.6c0 .11-.09.2-.2.2H4.2c-.11 0-.2-.09-.2-.2v-1.6c0-.11.09-.2.2-.2h15.6zm0-6c.11 0 .2.09.2.2v1.6c0 .11-.09.2-.2.2H4.2c-.11 0-.2-.09-.2-.2V5.2c0-.11.09-.2.2-.2h15.6z"></path></svg>
          </div>
        </div>
      </div>
      <div class="navbar-collapse menuInfo" :class="{ active: mobileMenuOpen }">
        <div class="navbar-collapse-content">
          <div class="yzButton-wrapper fboxRow">
            <div class="yzButton deep">
              <router-link rel="nofollow" to="/auth">{{ t('header.register') }}</router-link>
            </div>
            <div class="yzButton light">
              <a rel="nofollow" href="https://95008.com/auth">{{ t('header.login') }}</a>
            </div>
          </div>
          <div class="nav-item-wrapper" data-name="act">
            <router-link to="/activity">
              <div class="nav-content-item">
                <span class="iconfont icon-fire"></span>
                <span>{{ t('header.activities') }}</span>
              </div>
            </router-link>
          </div>
          <div v-for="cat in mobileNavItems" :key="cat.name" class="nav-item-wrapper" :data-name="cat.name">
            <div class="nav-content-item" @click="toggleMobileNav(cat.name)">
              <span class="iconfont icon-cloud-computing"></span>
              <span>{{ cat.label }}</span>
              <span class="icon el-icon-caret-bottom"></span>
            </div>
            <ul class="nav-ul-wrapper" :class="{ active: activeMobileNav === cat.name }">
              <router-link v-for="item in cat.items" :key="item.name" :to="item.link">
                <li class="nav-ul-li">{{ item.name }}</li>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { ref, computed, nextTick, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import {
  IconComputer,
  IconCloud,
  IconSafe,
  IconLock,
  IconFire,
  IconStorage,
  IconApps
} from '@arco-design/web-vue/es/icon'

const router = useRouter()
const { t } = useI18n()

const activeDropdown = ref(null)
const isDropdownActive = ref(false)
const activeCat = ref('all')
const lineTop = ref(0)
const mobileMenuOpen = ref(false)
const activeMobileNav = ref(null)

// 搜索功能 - 关键词滚动
const showSearchPanel = ref(false)
const searchQuery = ref('')
const searchInput = ref(null)
const currentKeywordIndex = ref(0)
const searchKeywords = computed(() => [
  t('search.cloudServer'),
  t('search.hkServer'),
  t('search.ddosProtection'),
  t('search.sslCertificate'),
  t('search.colocation')
])
let keywordTimer = null

let menuTimer = null
let leaveTimer = null

const dropdownStyle = computed(() => ({
  visibility: isDropdownActive.value ? 'visible' : 'hidden',
  height: isDropdownActive.value ? '450px' : '0px',
  overflow: 'hidden'
}))

const productCategories = computed(() => [
  { id: 'all', name: t('products.allProducts') },
  { id: 'server', name: t('products.physicalServer') },
  { id: 'rack', name: t('products.cabinetRental') },
  { id: 'cloud', name: t('products.cloudServer') },
  { id: 'antiddos', name: t('products.ddosProtection') },
  { id: 'crossline', name: t('products.crossBuildingLinks') },
  { id: 'msserver', name: t('products.multiIpServers') },
  { id: 'ssl', name: t('products.sslCertificates') },
  { id: 'domain', name: t('products.domains') }
])

const allProductGroups = computed(() => [
  { title: t('products.physicalServer'), icon: '/templates/scgidc/images/scg/icon/server.png', items: [
    { name: t('serverProducts.hkBgpPremium'), link: 'https://www.95008.com/store/hk', tag: 'hk' },
    { name: t('serverProducts.hkBgpStandard'), link: 'https://www.95008.com/store/bgpb', tag: 'hk' },
    { name: t('serverProducts.hkBgpGlobal'), link: 'https://www.95008.com/store/bgpg', tag: 'hk' },
    { name: t('serverProducts.hkBgpAntiDdos'), link: 'https://www.95008.com/store/bgpad', tag: 'hk' }
  ]},
  { title: t('products.cabinetRental'), icon: '/templates/scgidc/images/scg/icon/rack.png', items: [
    { name: t('serverProducts.hkColocation'), link: 'https://www.95008.com/store/colocation' }
  ]},
  { title: t('products.cloudServer'), icon: '/templates/scgidc/images/scg/icon/cloud.png', items: [
    { name: t('serverProducts.cloud'), link: 'https://www.95008.com/store/yun' }
  ]},
  { title: t('products.ddosProtection'), icon: '/templates/scgidc/images/scg/icon/antiddos.png', items: [
    { name: t('serverProducts.antiDdos'), link: 'https://www.95008.com/store/antiddos', tag: 'hk' }
  ]},
  { title: t('products.crossBuildingLinks'), icon: '/templates/scgidc/images/scg/icon/crossline.png', items: [
    { name: t('serverProducts.crossBuilding'), link: 'https://www.95008.com/store/crossline', tag: 'hk' }
  ]},
  { title: t('products.multiIpServers'), icon: '/templates/scgidc/images/scg/icon/msserver.png', items: [
    { name: t('serverProducts.siteCluster'), link: 'https://www.95008.com/store/zhan-qun-fu-wu-qi', tag: 'hk' }
  ]},
  { title: t('products.sslCertificates'), icon: '/templates/scgidc/images/scg/icon/ssl.png', items: [
    { name: t('serverProducts.ssl'), link: 'https://www.95008.com/store/ssl', tag: 'dv' }
  ]}
])

const serverProducts = computed(() => [
  { title: t('serverProducts.hkBgpPremium'), desc: t('serverProducts.hkBgpPremiumDesc'), link: 'https://www.95008.com/store/hk', consoleLink: 'https://95008.com/console/server' },
  { title: t('serverProducts.hkBgpStandard'), desc: '', link: 'https://www.95008.com/store/bgpb', consoleLink: 'https://95008.com/console/server' },
  { title: t('serverProducts.hkBgpGlobal'), desc: '', link: 'https://www.95008.com/store/bgpg', consoleLink: 'https://95008.com/console/server' },
  { title: t('serverProducts.hkBgpAntiDdos'), desc: '', link: 'https://www.95008.com/store/bgpad', consoleLink: 'https://95008.com/console/server' }
])

const serviceItems = [
  { titleKey: 'solutions.colocation', descKey: 'solutions.colocationDesc', link: 'https://95008.com/colocation.shtml' },
  { titleKey: 'solutions.bandwidth', descKey: 'solutions.bandwidthDesc', link: 'https://95008.com/pages/bandwidth/' },
  { titleKey: 'solutions.ipTransit', descKey: 'solutions.ipTransitDesc', link: 'https://95008.com/pages/iptransit/' },
  { titleKey: 'solutions.crossCloud', descKey: 'solutions.crossCloudDesc', link: 'https://95008.com/pages/crosscloud/' },
  { titleKey: 'solutions.hybridCloud', descKey: 'solutions.hybridCloudDesc', link: 'https://95008.com/pages/hybridcloud/' },
  { titleKey: 'solutions.dcInterconnect', descKey: 'solutions.dcInterconnectDesc', link: 'https://95008.com/pages/data-center-interconnect/' }
]

// 数据中心映射 - 避免动态i18n key问题
const datacenterMap = {
  'coresite-la1': 'CoreSite LA1',
  'west7': 'West7',
  'chief': 'Chief',
  'eq-ty8': 'Equinix TY8',
  'tyo1': 'Tokyo TYO1',
  'global-switch-woolands': 'Global Switch Woolands',
  'eq-sg1': 'Equinix SG1',
  'mega-i': 'MEGA-i Hong Kong',
  'globalswitch': 'Global Switch',
  'tgt': 'TGT'
}

const datacenters = computed(() => Object.entries(datacenterMap).map(([slug, name]) => ({
  name,
  slug
})))

const mobileNavItems = computed(() => [
  { name: 'server', label: t('products.physicalServer'), items: [
    { name: t('serverProducts.hkBgpPremium'), link: '/store/hk' },
    { name: t('serverProducts.hkBgpStandard'), link: '/store/bgpb' },
    { name: t('serverProducts.hkBgpGlobal'), link: '/store/bgpg' },
    { name: t('serverProducts.hkBgpAntiDdos'), link: '/store/bgpad' }
  ]},
  { name: 'cloud', label: t('products.cloudServer'), items: [
    { name: t('serverProducts.cloud'), link: '/store/yun' }
  ]},
  { name: 'antiddos', label: t('products.ddosProtection'), items: [
    { name: t('serverProducts.antiDdos'), link: '/store/antiddos' }
  ]}
])

function handleMenuEnter(menu) {
  if (leaveTimer) clearTimeout(leaveTimer)
  if (menuTimer) clearTimeout(menuTimer)
  
  const delay = isDropdownActive.value ? 300 : 100
  menuTimer = setTimeout(() => {
    activeDropdown.value = menu
    isDropdownActive.value = true
    activeCat.value = 'all'
    lineTop.value = 0
  }, delay)
}

function handleMenuLeave() {
  if (menuTimer) clearTimeout(menuTimer)
  leaveTimer = setTimeout(() => {
    hideDropdown()
  }, 200)
}

function handleDropdownEnter() {
  if (leaveTimer) clearTimeout(leaveTimer)
}

function handleDropdownLeave() {
  leaveTimer = setTimeout(() => {
    hideDropdown()
  }, 200)
}

function hideDropdown() {
  isDropdownActive.value = false
  activeDropdown.value = null
  activeCat.value = 'all'
  lineTop.value = 0
}

function handleCatHover(catId, index) {
  activeCat.value = catId
  lineTop.value = index * 40
}

function toggleMobileMenu() {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

function toggleMobileNav(name) {
  activeMobileNav.value = activeMobileNav.value === name ? null : name
}

// 搜索功能 - 关键词轮播
function startKeywordRotation() {
  keywordTimer = setInterval(() => {
    currentKeywordIndex.value = (currentKeywordIndex.value + 1) % searchKeywords.value.length
  }, 2500)
}

function stopKeywordRotation() {
  if (keywordTimer) {
    clearInterval(keywordTimer)
    keywordTimer = null
  }
}

function openSearchPanel() {
  showSearchPanel.value = true
  stopKeywordRotation()
  nextTick(() => {
    searchInput.value?.focus()
  })
}

function closeSearchPanel() {
  showSearchPanel.value = false
  startKeywordRotation()
}

function handleSearch() {
  if (searchQuery.value.trim()) {
    window.location.href = `/docs?search=${encodeURIComponent(searchQuery.value)}`
  }
}

function goTo(path) {
  closeSearchPanel()
  router.push(path)
}

onMounted(() => {
  startKeywordRotation()
})

onUnmounted(() => {
  stopKeywordRotation()
})
</script>


<style scoped>
/* 搜索框 - 高度撑满、无圆角、左右边框 */
.header-search-wrapper {
  position: relative;
  height: 64px;
  display: flex;
  align-items: stretch;
}
.header-search-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  height: 100%;
  background: transparent;
  border-left: 1px solid rgba(255,255,255,0.12);
  border-right: 1px solid rgba(255,255,255,0.12);
  cursor: pointer;
  transition: all 0.3s;
  min-width: 160px;
}
.header-search-wrapper.is-expanded .header-search-box {
  min-width: 300px;
  background: rgba(255,255,255,0.05);
}
.header-search-box:hover {
  background: rgba(255,255,255,0.05);
}
.search-keyword-scroll {
  flex: 1;
  height: 20px;
  overflow: hidden;
  position: relative;
}
.keyword-item {
  display: block;
  color: rgba(255,255,255,0.6);
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
}
.search-input-inline {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
}
.search-input-inline::placeholder {
  color: rgba(255,255,255,0.5);
}
.search-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255,255,255,0.6);
}
.close-icon {
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s;
}
.close-icon:hover {
  opacity: 1;
}

/* Docs链接 - 无竖线 */
.header-docs-link {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 64px;
  color: rgba(255,255,255,0.85);
  font-size: 14px;
  text-decoration: none;
  transition: color 0.2s;
}
.header-docs-link:hover {
  color: #fff;
}

/* 关键词滚动动画 */
.keyword-slide-enter-active,
.keyword-slide-leave-active {
  transition: all 0.4s ease;
}
.keyword-slide-enter-from {
  transform: translateY(100%);
  opacity: 0;
}
.keyword-slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

/* 下方浮窗 - Arco Tag组件样式 */
.search-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  box-shadow: 0 8px 32px rgba(0,0,0,0.15);
  z-index: 100;
  padding: 20px 24px;
  min-width: 420px;
  border-radius: 0 0 12px 12px;
}
.search-section {
  margin-bottom: 18px;
}
.search-section:last-child {
  margin-bottom: 0;
}
.search-section-title {
  font-size: 13px;
  color: #666;
  font-weight: 600;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

/* Arco Tag样式增强 */
:deep(.arco-tag) {
  cursor: pointer;
  font-size: 14px !important;
  padding: 6px 14px !important;
  border-radius: 6px !important;
}
:deep(.arco-tag:hover) {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
:deep(.arco-space) {
  gap: 10px !important;
}

/* 强制显示下拉菜单 */
.pls-nav-dropdown {
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 8px 20px rgba(55, 99, 170, 0.15);
  z-index: 99;
}
.pls-nav-dropdown__wrapper.is-active {
  height: 100%;
  opacity: 1;
  transform: translate(0, 0);
}
</style>
